import React, { useState, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import {
    Box, Switch,
    Button,
    Typography,
    Card,
    CardContent,
    Chip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Grid,
    Divider,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    LinearProgress,
    Avatar,
    AvatarGroup, Modal,
    Tooltip,
    Autocomplete, Alert, Pagination

} from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { styled } from '@mui/material/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AssignmentIcon from '@mui/icons-material/Assignment';
import TimelineIcon from '@mui/icons-material/Timeline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import CancelIcon from '@mui/icons-material/Cancel';
import GroupsIcon from '@mui/icons-material/Groups';
import BusinessIcon from '@mui/icons-material/Business';
import FlagIcon from '@mui/icons-material/Flag';
import SpeedIcon from '@mui/icons-material/Speed';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import CodeIcon from '@mui/icons-material/Code';
import StorageIcon from '@mui/icons-material/Storage';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import axios from 'axios';
import { axiosInstance, localAxios, localAxiosGet, localAxiosPut, localAxiosToken } from "../../../Axios/axios"
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { formatDistanceToNow } from 'date-fns';
import { Loader } from '../../../components/loade';
import EditProjectDetails from '../Projects/EditProjectDetails';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import AllProjects from './AllProjects';
import EmployeeProjects from '../../Employee/Projects/EmployeeProjects';
import UpdateAssignTeam from './UpdateAssignTeam';
import CreateProject from './CreateProject';

const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        borderRadius: '12px',
        padding: theme.spacing(2),
        minWidth: '500px'
    }
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(3),
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    height: '100%',
    background: 'linear-gradient(135deg, #E3EEFF 0%, #F3E7FF 100%)',
    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 6px 24px rgba(59, 130, 246, 0.2)'
    }
}));

export const ProjectList = ({ onProjectSelect, onViewTasks }) => {
    const navigate = useNavigate();
    const organizationId = localStorage.getItem('organizationId');
    const [isLoading, setIsLoading] = useState(false);
    const [cardData, setCardData] = useState([]);
    const [projectDetailsFromApi, setProjectDetailsFromAPi] = useState([])
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [openDialog, setOpenDialog] = useState(false);
    const [newProject, setNewProject] = useState({
        name: '',
        client: '',
        projectManager: null,
        teamLead: null,
        startDate: null,
        endDate: null,
        status: 'Todo',
        description: '',
        priority: 'Medium',
        progress: 0,
        manager_id: null,
        team_leader_id: null
    });
    const [teamLeadOptions, setTeamLeadOptions] = useState([]);
    const [managerOptions, setmanagerOptions] = useState([]);
    const [managerInputValue, setManagerInputValue] = useState('');
    const [leadInputValue, setLeadInputValue] = useState('');
    const [selectedProject, setSelectedProject] = useState(null);
    const [selectedProjectId, setSelectedProjectId] = useState(null);
    const [openProjectDetailsDialog, setOpenProjectDetailsDialog] = useState(false);
    const [showMyProjects, setShowMyProjects] = useState(false);
    const [isToggleLoading, setIsToggleLoading] = useState(false);

    const [allDepartmentsNames, setAllDepartmentsNames] = useState([]);
    const [teamName, setTeamName] = useState([]); // All available teams
    const [addedTeams, setAddedTeams] = useState([]); // Array to hold data for each added team
    const [allTeamsSelected, setAllTeamsSelected] = useState(false); // Explicit state for tracking
    const [projectDetailsFromProjectsApi, setProjectDetailsFromProjectsApi] = useState('');

    const [existingTeamsData, setExistingTeamsData] = useState([]); // Data from the API for existing teams
    const [allTeamMembersForExisting, setAllTeamMembersForExisting] = useState({}); // { teamId: [allMembers] }
    //const [existingTeams, setExistingTeams] = useState()
    const [isExistingTeamsData, setIsExistingTeamsData] = useState(false);
    const [isExistingTeams, setIsExistingTeams] = useState(false);
    const [editedExistingTeams, setEditedExistingTeams] = useState({}); // { teamId: [selectedMembers] }

    const [isEditing, setIsEditing] = useState(false);
    const [projectIdToEdit, setProjectIdToEdit] = useState(null);

    const userId = localStorage.getItem('userId');
    // console.log('userId', userId)
    const accessToken = localStorage.getItem('accessToken');
    // console.log('accessToken', accessToken)
    const departmentId = localStorage.getItem('departmentId');
    const userType = localStorage.getItem('userType')
    const [paginationData, setPaginationData] = useState({
        total: 0,
        totalPages: 1,
        currentPage: 1,
        total_project_count: 0,
        todo_project_count: 0,
        inprogress_count: 0,
        overdue_count: 0
    });
    const [rowsPerPage, setRowsPerPage] = useState(10);


    const handleEdit = (id) => {
        setProjectIdToEdit(id);
        setIsEditing(true);

    };

    const handleCloseEdit = () => {
        setIsEditing(false);
        setProjectIdToEdit(null);
        fetchProjectData();
    };

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {        
        setOpenDialog(false);
        setNewProject({
            name: '',
            client: '',
            startDate: null,
            endDate: null,
            status: 'Todo',
            description: '',
            priority: 'Medium',
            progress: 0
        });
    };

    const handleOnProjectCreateSuccess =() =>{
        fetchProjectData()
    }
    const [noProjectsFoundError, setNoProjectsFoundError] = useState(false);

    useEffect(() => {
        fetchProjectData();

    }, [userId]);


    const fetchProjectData = async (status = '', page = 1, limit = rowsPerPage) => {
        setIsLoading(true);
        setNoProjectsFoundError(false);
        try {
            // let url = `/project/getProjectsByManagerId/${userId}?page=${page}&limit=${limit}`;
            let url = `/project/getProjectsBySupervisorId/${userId}?page=${page}&limit=${limit}`;
            if (status) {
                url += `&status=${status}`;
            }

            const projectResponse = await axiosInstance(localAxiosGet(url, accessToken));
            // console.log('project data', projectResponse.data);


            setProjectDetailsFromAPi(projectResponse.data.message.data);


            setPaginationData({
                total: projectResponse.data.message.total,
                totalPages: projectResponse.data.message.totalPages,
                currentPage: projectResponse.data.message.currentPage,
                total_project_count: projectResponse.data.message.total_project_count,
                todo_project_count: projectResponse.data.message.todo_project_count,
                inprogress_count: projectResponse.data.message.inprogress_count,
                overdue_count: projectResponse.data.message.overdue_count
            });

        } catch (error) {
            console.error('Error while fetching project data', error);

            if (axiosInstance.isAxiosError(error) && error.response && error.response.status === 404) {
                setNoProjectsFoundError(true);
                setProjectDetailsFromAPi([]);
            } else {

                setNoProjectsFoundError(false);
                setProjectDetailsFromAPi([]);

            }
        } finally {
            setTimeout(() => {
                setIsLoading(false);
            }, 2000);
        }
    };



    useEffect(() => {
        const updateCardData = () => {

            setCardData([
                {
                    title: 'All Projects',
                    count: paginationData?.total_project_count || 0,
                    icon: <TrendingUpIcon sx={{ fontSize: 40, color: 'white' }} />,
                    gradient: 'linear-gradient(135deg, #6366F1 0%, #A855F7 100%)',
                    key: 'all'
                },
                {
                    title: 'Todo',
                    count: paginationData?.todo_project_count || 0,
                    icon: <AssignmentIcon sx={{ fontSize: 40, color: 'white' }} />,
                    gradient: 'linear-gradient(135deg, #FF6B6B 0%, #FFE66D 100%)',
                    key: 'todo'
                },
                {
                    title: 'Ongoing',
                    count: paginationData?.inprogress_count || 0,
                    icon: <TimelineIcon sx={{ fontSize: 40, color: 'white' }} />,
                    gradient: 'linear-gradient(135deg, #4ECDC4 0%, #556270 100%)',
                    key: 'ongoing'
                },
                {
                    title: 'Overdue',
                    count: paginationData?.overdue_count || 0,
                    icon: <AccessAlarmIcon sx={{ fontSize: 40, color: 'white' }} />,
                    gradient: 'linear-gradient(135deg, #FFA000 0%, #FFC107 100%)',
                    key: 'overdue'
                }
            ]);
        };

        updateCardData();
    }, [paginationData]);

    // console.log('projectsFromApi', projectDetailsFromApi)
    const handleCardClick = (cardKey) => {
        setSelectedCategory(cardKey);


        if (cardKey === 'all') {
            fetchProjectData('', 1, 10);
        } else {
            const statusMap = {
                'todo': 'Todo',
                'ongoing': 'In Progress',
                'overdue': 'Overdue'
            };
            fetchProjectData(statusMap[cardKey], 1, 10);
        }
    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                const teamLeadresponse = await axiosInstance(localAxiosGet(`/project/getAllTeamLeadOrManager?organization_id=${organizationId}&is_team_lead=true`, accessToken));
                // console.log('Response data:', teamLeadresponse.data);

                if (teamLeadresponse.data && teamLeadresponse.data.message && teamLeadresponse.data.message.users) {
                    const options = teamLeadresponse.data.message.users.map(user => ({
                        id: user.id,
                        name: `${user.first_name} ${user.last_name}`
                    }));
                    setTeamLeadOptions(options);
                    // console.log('teamleadoptions', options);
                }

                const managerResponse = await axiosInstance(localAxiosGet(`/project/getAllTeamLeadOrManager?organization_id=${organizationId}&is_manager=true`, accessToken));

                if (managerResponse.data && managerResponse.data.message && managerResponse.data.message.users) {
                    const options = managerResponse.data.message.users.map(user => ({
                        id: user.id,
                        name: `${user.first_name} ${user.last_name}`
                    }));
                    setmanagerOptions(options);
                    // console.log('manager options', options);
                }

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        fetchData();



    }, [organizationId])


    const handleCreateProject = async () => {
        setIsLoading(true);
        try {
            if (newProject.name && newProject.client && newProject.startDate && newProject.endDate) {

                const newProjectItem = {
                    //id: Math.max(...currentProjects.map(p => p.id || 0), 0) + 1,
                    ...newProject,
                    startDate: newProject.startDate.toISOString(),
                    endDate: newProject.endDate.toISOString(),
                    teamMembers: []
                };

                const requriedData = {
                    organization_id: organizationId,
                    project_title: newProject.name,
                    priority: newProject.priority,
                    start_date: newProjectItem.startDate,
                    end_date: newProjectItem.endDate,
                    description: newProject.description,
                    clients: (() => {
                        if (newProject.client && newProject.client.trim() !== '') {
                            const clientNameParts = newProject.client.trim().split(' ');
                            if (clientNameParts.length >= 2) {
                                return [{
                                    first_name: clientNameParts[0],
                                    last_name: clientNameParts.slice(1).join(' ')
                                }];
                            } else {
                                return [{
                                    first_name: newProject.client.trim(),
                                    last_name: ''
                                }];
                            }
                        } else {
                            return [];
                        }

                    })(),
                    status: newProject.status,
                    progress: newProject.progress,
                    manager_id: newProject.manager_id,
                    team_leader_id: newProject.team_leader_id,
                }
                try {
                    const config = localAxiosToken(`/project/createProject`, requriedData);
                    const response = await axiosInstance(config.url, config);
                    //console.log('response for creating project', response);

                } catch (error) {
                    console.error('Error in creating the project', error.response ? error.response.data : error.message)
                }

                fetchProjectData();
                handleCloseDialog();
            } else {
                alert('Please fill in all required fields!');
            }
        } catch (error) {
            console.error('Error creating project:', error);
            alert('Error creating project. Please try again.');
        } finally {
            setTimeout(() => {
                setIsLoading(false);
            }, 2000);
        }
    };


    const handleDelete = () => {

    }

    const handleCloseProjectdetailsDialog = () => {
        setOpenProjectDetailsDialog(false);
    };


    const getFirstLetter = (projectName) => {
        if (projectName && projectName.length > 0) {
            return projectName.charAt(0).toUpperCase();
        } else {
            return '';
        }
    };


    const handleProjectClick = async (project) => {
        setIsLoading(true);
        setSelectedProject(project);
        setSelectedProjectId(project.id);
        setOpenProjectDetailsDialog(true);
        setIsLoading(false);
    };

    const handleToggleChange = () => {
        setIsToggleLoading(true);
        setShowMyProjects(!showMyProjects);
        setTimeout(() => {
            setIsToggleLoading(false);
        }, 2000);
    };

    const getFilteredProjects = () => {
        if (selectedCategory === 'all') {
            return projectDetailsFromApi;
        } else {

            const statusMap = {
                'todo': 'Todo',
                'ongoing': 'In Progress',
                'completed': 'Completed'
            };

            return projectDetailsFromApi.filter(project =>
                project.status === statusMap[selectedCategory]
            );
        }
    };

    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
        fetchProjectData(
            selectedCategory === 'all' ? '' :
                selectedCategory === 'todo' ? 'Todo' :
                    selectedCategory === 'ongoing' ? 'In Progress' : 'Overdue',
            1, // Reset to first page
            newRowsPerPage
        );
    };



    return (
        <Box sx={{ p: { lg: 2, xl: 3 } }}>
            <ToastContainer />

            {isLoading && (
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "rgba(0, 0, 0, 0.7)",
                        zIndex: 10000,
                        backdropFilter: "blur(3px)",
                    }}
                >
                    <Loader />
                </Box>
            )}
            
                <Box>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        justifyContent: 'space-between',
                        alignItems: { xs: 'start', md: 'center' },
                        mb: { xs: 1, md: 4 },
                        mt: { xs: 2, md: 0 }
                    }}>
                        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', pl: { xs: 1, md: 0 } }}>
                            {!showMyProjects && (
                                <Typography variant="h5" sx={{ fontWeight: 600, color: '#1e293b' }}>
                                    Projects Overview
                                </Typography>
                            )}
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            alignItems: { xs: 'end', md: 'center' },
                            flexDirection: { xs: 'column', sm: 'row' },
                            justifyContent: { xs: 'flex-end' },
                            gap: { xs: 0.1, md: 2 },
                            alignSelf: 'flex-end',
                            mt: { xs: 1, md: 0 },
                            pr: { xs: 1, md: 0 }
                        }}>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                p: 1,
                                borderRadius: 2,
                                transition: 'all 0.3s ease'
                            }}>
                                <Typography
                                    sx={{
                                        mr: 1,
                                        color: showMyProjects ? '#64748b' : '#3b82f6',
                                        fontWeight: showMyProjects ? 400 : 600,
                                        transition: 'all 0.3s ease'
                                    }}
                                >
                                    All
                                </Typography>
                                <Box sx={{ position: 'relative' }}>
                                    <Switch
                                        checked={showMyProjects}
                                        onChange={handleToggleChange}
                                        color="primary"
                                        disabled={isToggleLoading}
                                    />
                                    {isToggleLoading && <Loader />}
                                </Box>
                                <Typography
                                    sx={{
                                        ml: 1,
                                        color: showMyProjects ? '#3b82f6' : '#64748b',
                                        fontWeight: showMyProjects ? 600 : 400,
                                        transition: 'all 0.3s ease'
                                    }}
                                >
                                    My Projects
                                </Typography>
                            </Box>
                            {userType === 'Manager' && (
                            <Button
                                variant="contained"
                                startIcon={<AddIcon />}
                                onClick={handleOpenDialog}
                                sx={{
                                    backgroundColor: '#3b82f6',
                                    textTransform: 'none',
                                    '&:hover': { backgroundColor: '#2563eb' }
                                }}
                            >
                                New Project
                            </Button>
                            )}
                        </Box>
                    </Box>
                    {showMyProjects ? (
                        <Box sx={{ mt: '-70px' }}>
                            <EmployeeProjects />
                        </Box>
                    ) : (
                        <AllProjects
                            projectDetailsFromApi={projectDetailsFromApi}
                            noProjectsFoundError={noProjectsFoundError}
                            onProjectClick={handleProjectClick}
                            onViewTasks={onViewTasks}
                            paginationData={paginationData}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleRowsPerPageChange}
                            onPageChange={(event, page) => {
                                fetchProjectData(
                                    selectedCategory === 'all' ? '' :
                                        selectedCategory === 'todo' ? 'Todo' :
                                            selectedCategory === 'ongoing' ? 'In Progress' : 'Overdue',
                                    page,
                                    rowsPerPage
                                );
                            }}
                            handleCardClick={handleCardClick}
                            selectedCategory={selectedCategory}
                            handleEdit={handleEdit}
                            handleDelete={handleDelete}
                        />
                    )}
                </Box>
            
                

            <CreateProject open={openDialog}
                onClose={handleCloseDialog}
                onProjectCreateSuccess={handleOnProjectCreateSuccess}
                />


            <UpdateAssignTeam
                open={openProjectDetailsDialog}
                onClose={handleCloseProjectdetailsDialog}
                selectedProject={selectedProject}
                selectedProjectId={selectedProjectId}
                accessToken={accessToken}
                departmentId={departmentId}
                organizationId={organizationId}
                onTeamAssignSuccess={() => {
                    fetchProjectData();
                }}
            />



            {isEditing && (
                <Modal
                    open={isEditing}
                    onClose={handleCloseEdit}
                    aria-labelledby="edit-project-modal-title"
                    aria-describedby="edit-project-modal-description"
                >
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: 800,
                            bgcolor: 'background.paper',
                            p: 3,
                            borderRadius: '8px'
                        }}
                    >
                        <EditProjectDetails
                            selectedProjectId={projectIdToEdit}
                            managerOptions={managerOptions}
                            teamLeadOptions={teamLeadOptions}
                            onClose={handleCloseEdit} />
                    </Box>
                </Modal>
            )}
        </Box>


    );
};

export default ProjectList;